module.exports = __webpack_public_path__ + "static/plant-0ec1b80c5c7cc22209acafc421e9f881.png";